// 交易来源 | 交易状态
import * as React from "react";
import { Select } from "antd";
const Option = Select.Option;
import { connect } from "react-redux";

interface ITradeSourceProps {
  width?: any;
  value: any;
  getTradeSource?: any;
  getTradingStatus?: any;
  share?: any;
  onChange?: any;
  resetTradingStatus?: any;
  setValue?: any;
  modelName?: any;
}

class TradeSource extends React.Component<ITradeSourceProps, any> {
  constructor(props: ITradeSourceProps) {
    super(props);
  }

  componentDidMount() {
    // 渲染完组件后加载贸易来源数据
    this.props.getTradeSource();
  }

  // 更新交易来源选择项时触发
  // e:更改后的值
  onChangeTradeSource = e => {
    // 重置交易状态二级类目数据集
    this.props.resetTradingStatus();

    // 重置二级类目选择项
    let data = { model: this.props.modelName, formInfo: {} };
    data.formInfo[this.props["tradingStatus-field"]] = "";
    this.props.setValue(data);

    // 只有在主分类有值时才初始化、
    if (e) {
      // 获取贸易状态
      this.props.getTradingStatus(e);
    }

    this.props.onChange && this.props.onChange(e, this.props["data-field"]);
  };

  render() {
    const list = this.props.share.tradeSource;
    const mapList = () => {
      let options: any = [];
      for (const item of list) {
        options.push(
          <Option key={item.id} value={item.id}>
            {item.name}
          </Option>
        );
      }
      return options;
    };

    // 当数据已加载完成时才设置选中的值,这样处理可以避免由于数据集为加载而造成的闪烁
    const value = this.props.share.tradeSource.length
      ? this.props.value || undefined
      : undefined;

    // 根据关键字检索option
    const filter = (input, option) =>
      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;

    return (
      <Select
        style={{ width: this.props.width || 200 }}
        value={value}
        allowClear={true}
        placeholder="选择交易来源"
        onChange={this.onChangeTradeSource}
        // 检索相关
        showSearch
        optionFilterProp="children"
        filterOption={filter}
        // 检索相关
      >
        {mapList()}
      </Select>
    );
  }
}

const mapState = state => ({
  share: state.share
});

const mapDispatch = dispatch => {
  return {
    // 获取贸易来源方法
    getTradeSource: dispatch.tradingStatus.getTradeSource,
    // 获取贸易状态方法
    getTradingStatus: dispatch.tradingStatus.getTradingStatus,
    // 重置二级类目数据
    resetTradingStatus: dispatch.share.resetTradingStatus,
    setValue: dispatch.antDemo.setValue
  };
};

export default connect(
  mapState,
  mapDispatch
)(TradeSource);
